import { MSG_PROCESSING_STATUS_ID } from '../../../Helpers/Chat/Constant';
import { parseDisappearAtMs } from '../../../Helpers/Chat/disappearTime';
import { isLocalUser } from '../../../Helpers/Chat/User';
import { normalizeViewOnce } from '../../../Helpers/Chat/viewOnce';

export const KEEP_ACTION = {
    KEEP: 'keep',
    UNKEEP: 'unkeep',
};

/**
 * Whether a message may be kept: it must be on the server and still counting down.
 *
 * @param {object} message Message object of the thread.
 * @param {number} now Current time in ms.
 * @returns {boolean} True when Keep can be offered.
 */
export const isKeepableMessage = (message, now = Date.now()) => {
    if (!message?.msgId) return false;
    if (Number(message.msgStatus) === MSG_PROCESSING_STATUS_ID) return false;
    if (normalizeViewOnce(message.viewOnce) === 1) return false;
    const expiryMs = parseDisappearAtMs(message.disappear_at || message.disappearAt);
    return Number.isFinite(expiryMs) && expiryMs > now;
};

/**
 * The keep action the message menu offers, if any.
 *
 * Only the keeper may unkeep, so a message kept by someone else offers nothing.
 *
 * @param {object} message Message object of the thread.
 * @param {{isKept: boolean, keptBy: string}|undefined} keepState From selectKeepState.
 * @returns {string|null} A KEEP_ACTION value, or null.
 */
export const getKeepMenuAction = (message, keepState) => {
    if (keepState?.isKept) return isLocalUser(keepState.keptBy) ? KEEP_ACTION.UNKEEP : null;
    return isKeepableMessage(message) ? KEEP_ACTION.KEEP : null;
};

/**
 * Whether an unkept message's timer has already run out.
 *
 * @param {object} message Message object, if loaded.
 * @param {boolean} isExpiredByServer The server's verdict at unkeep time.
 * @param {number} now Current time in ms.
 * @returns {boolean} True when the message must disappear now.
 */
export const isExpiredOnUnkeep = (message, isExpiredByServer, now = Date.now()) => {
    if (isExpiredByServer) return true;
    const expiryMs = parseDisappearAtMs(message?.disappear_at || message?.disappearAt);
    return Number.isFinite(expiryMs) && expiryMs <= now;
};
